import React from "react";

export default function VCWhy() {
  return (
    <section
      data-testid="vc-why-section"
      className="bg-[#F4F6F4] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="text-xs uppercase tracking-[0.2em] font-bold text-teal mb-4">
              Why school leaders take it
            </div>
            <h2
              data-testid="vc-why-headline"
              className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-navy leading-tight"
            >
              Great Work Deserves to Be{" "}
              <span className="text-teal">Seen.</span>
            </h2>
          </div>

          <div className="lg:col-span-7 space-y-5 text-base sm:text-lg text-slate-700 leading-relaxed">
            <p>
              Many schools are doing incredible work.{" "}
              <strong className="text-navy">
                The challenge is making that work visible.
              </strong>
            </p>
            <p>
              The Visibility Check<sup>™</sup> helps identify opportunities to
              strengthen communication, recognition, school pride, event
              participation, and overall engagement.
            </p>
            <p className="border-l-4 border-teal pl-5 italic">
              The result is a clearer understanding of how effectively your
              school communicates and celebrates what matters most.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
